import React from "react";
import Headline from "./Headline";
import LocationsApi from "../../api-services/locations-api.service";
import { Flex, notification } from "antd";
import LocationPostcards from "../../components/shared/LocationPostcards";
import HomeLink from "../../widgets/HomeLink";
import { Link, useParams } from "react-router-dom";

const bannerPath = '/iceholidays-assets/images/gd_classic.png';

const series = {
  "gd-classics": {header: "GD Classics", brand: "GD_Standard"},
  // "gd-indepth": {header: "GD In-Depth", brand: "GD_In_Depth"},
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}

class SeriesShowPage extends React.Component <{params}>  {
  locationsApi = new LocationsApi;

  state = {
    breadcrumbs: [],
    location: {id: null, name: "", children: [], cover: "", description: ""}
  }

  seriesByType = series[this.props.params.type];

  componentDidMount() {
    this.locationsApi.getLocation(this.props.params.id)
      .then(location => {
        const breadcrumbs = [
          { title: <HomeLink/>},
          { title: <Link to={`/web/series-tour/${this.props.params.type}`}> {this.seriesByType?.header} </Link> },
          { title: location.name }
        ]
        this.setState({location, breadcrumbs})
      })
      .catch(error => {
        notification.error({ message: `An error occured while loading ${this.seriesByType?.brand}.`});
      });
  }


  render(){
    const {breadcrumbs, location} = this.state;
    const listingLink = (locator) => {
      return `/web/listing?keyword=${locator.name}&location_id=${locator.id}&brands[]=${this.seriesByType?.brand}`;
    }

    return (
      <div id="gd-classic" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={location.cover || bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            {location?.name}
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          {
            location?.description && 
              <div className="introduction">
                <Flex vertical gap={8}>
                  <div className="introduction_header"> <h1>Introduction</h1> </div>
                  <div className="introduction_body">
                    {location?.description}
                  </div>
                </Flex>
              </div>
          }

          <LocationPostcards locations={location?.children} listingLink={(locator)=>listingLink(locator)}/>
        </div>

      </div>
    )
  }
}

export default withParams(SeriesShowPage);